import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomHttpRequestEncoder } from './custom-http-request-encoder.class';

@Injectable()
export class EncodeHttpParamsInterceptor implements HttpInterceptor {
  /**
   * @description Interceptor that overrides/fixes incorrect default angular params encoding.
   * @param { HttpRequest<any> } request The outgoing request to handle.
   * @param { HttpHandler } next The next interceptor in the chain, or the backend if no interceptors in
   *                           the chain.
   * @returns { Observable<HttpEvent<any>> } An observable of the event stream.
   */
  public intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const params: HttpParams = new HttpParams({
      encoder: new CustomHttpRequestEncoder(),
      fromString: req.params.toString(),
    });
    return next.handle(req.clone({ params }));
  }
}
